import * as kpisServices from '@/services/kpis.js'
import isEmpty from 'lodash/isEmpty'

export default {
  async empresaPrimeiroRegistro({ state, getters, commit }, filter) {
    if (!isEmpty(state.primeiroRegistro) && typeof filter === 'boolean') return

    const { data } = await kpisServices.datasLimites({})

    commit('SET_OBJECT', { name: 'primeiroRegistro', data, state })
  },
  async empresaItens({ state, commit }, filter) {
    const { data } = await kpisServices.totalItens(filter)
    commit('SET_OBJECT', { name: 'itens', data, state })
    return data
  },
  async empresaMediaItens({ state, commit }, filter) {
    const { data } = await kpisServices.mediaItens(filter)
    commit('SET_OBJECT', { name: 'mediaItens', data, state })
    return data
  },
  async empresaTicketMedio({ state, commit }, filter) {
    const { data } = await kpisServices.ticketMedio(filter)
    commit('SET_OBJECT', { name: 'ticketMedio', data, state })
    return data
  },
  async empresaCupons({ state, commit }, filter) {
    const { data } = await kpisServices.cupons(filter)
    commit('SET_OBJECT', { name: 'cupons', data, state })
    return data
  },
  async empresaFaturamento({ state, commit }, filter) {
    const { data } = await kpisServices.faturamento(filter)
    commit('SET_OBJECT', { name: 'faturamento', data, state })
    return data
  },
  async empresaClientesChart({ state, commit }, filter) {
    const { data } = await kpisServices.clientesCadastrados(filter)
    commit('SET_OBJECT', { name: 'clientesChart', data, state })
    return data
  },
  async empresaClientesTotal({ state, commit }, filter) {
    const { data } = await kpisServices.clientesCadastrados(filter)
    commit('SET_OBJECT', { name: 'clientesTotal', data, state })
  },
  async empresaClientesAtivos({ state, commit }, filter) {
    const { data } = await kpisServices.clientesAtivos(filter)
    commit('SET_OBJECT', { name: 'clientesAtivos', data, state })
  },
  async empresaClientesFidelidade({ state, commit }, filter) {
    const { data } = await kpisServices.clientesCadastrados(filter)
    commit('SET_OBJECT', { name: 'clientesFidelidade', data, state })
  },
  async empresaClientesFora({ state, commit }, filter) {
    const { data } = await kpisServices.clientesCadastrados(filter)
    commit('SET_OBJECT', { name: 'clientesFora', data, state })
  },
  async empresaInicioFidelidade({ state, commit }) {
    const { data } = await kpisServices.inicioFidelidade()
    commit('SET_OBJECT', { name: 'inicioFidelidade', data, state })
  },
  async empresaCuponsUltimos({ state, commit }, filter) {
    const { data } = await kpisServices.cupons(filter)
    commit('SET_OBJECT', { name: 'cuponsUltimos', data, state })
  },
  async empresaFaturamentoDta({ state, commit }, filter) {
    const { data } = await kpisServices.faturamentoDta(filter)
    return data
  },
  async empresaFaturamentoRaw({ state, commit }, filter) {
    const { data } = await kpisServices.faturamento(filter)
    return data
  },
}
